import { inject, InjectionToken, Provider } from '@angular/core';
import { SubmittedDocumentsSignalState } from '../types';
import { SUBMITED_DOCUMENTS_SIGNAL_STORE } from '../store/signal-store';

export const DOCUMENTS_TOKEN =
  new InjectionToken<SubmittedDocumentsSignalState>('Submitted Documents');

export const SUBMITTED_DOCS_PROVIDER: Provider = {
  provide: DOCUMENTS_TOKEN,
  useClass: SUBMITED_DOCUMENTS_SIGNAL_STORE,
};

export function submittedDocsTokenizer() {
  return inject(DOCUMENTS_TOKEN);
}
